<template>
    <div ref="pdfPreview" class="pdf-preview" v-if="src">
        <vue-pdf-embed :source="src" />
    </div>
</template>

<script>
    export default {
        name: "PdfPreview",
    };
</script>

<script setup>
    import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
    import { onMounted, onUnmounted, ref } from "vue";

    const pdfPreview = ref();

    const contextMenuListener = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    defineProps({
        src: {
            type: String,
            required: true,
        },
    });

    onMounted(() => {
        document.addEventListener("contextmenu", contextMenuListener);
    });

    onUnmounted(() => {
        document.removeEventListener("contextmenu", contextMenuListener);
    });
</script>

<style lang="scss" scoped>
    .pdf-preview {
        display: grid;
        user-select: none;
        pointer-events: none;
        overflow-y: scroll;
    }
</style>
